import { render, staticRenderFns } from "./InputSuffix.vue?vue&type=template&id=ad1ebc22"
import script from "./InputSuffix.vue?vue&type=script&lang=js"
export * from "./InputSuffix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports